<template>
  <h1 class="dashboard-title">Toegangsbeheer</h1>

  <div class="manage-bvs-container">
    <header class="header-section">
      <h1 class="page-title">Dashboardbeheer</h1>
      <SearchBar @search="handleSearch"/>
    </header>
    <BvTable
        @remove-user="removeUser"
        :users="filteredUsers"
        @update-permission="handlePermissionUpdate"
    />
  </div>
</template>

<script lang="ts" setup>
import {defineComponent, ref, computed, onMounted} from 'vue'
import type {BvUser} from './types'
import SearchBar from './SearchBar.vue'
import BvTable from './BVTable.vue'
import {useAuth} from "../composables/useAuth";


const searchQuery = ref('')
const users = ref<BvUser[]>([])
const removeUser = (id: number) => {
  let userIndex = users.value.findIndex((user: BvUser) => user.id === id)
  console.log(id)
  console.log(userIndex)
  if (userIndex !== -1) {
    users.value = users.value.map(user => {
      if (user.id === id) {
        return {
          ...user,
          updatingUser: true
        }
      } else {
        return user
      }
    })
    console.log(users.value[userIndex])
    auth.updateUser(users.value[userIndex]).then(() => {
      users.value = users.value.map(user => {
        if (user.id === id) {
          return {
            ...user,
            updatingUser: false,
          }
        } else {
          return user
        }
      })
    }).catch((error) => {
      console.error("Error updating user:", error);
    })
  }
}
const filteredUsers = computed(() => {
  const query = searchQuery.value.toLowerCase()
  return users.value.filter(user =>
      `${user.firstName} ${user.lastName}`?.toLowerCase()?.includes(query) ||
      user.companyName?.toLowerCase()?.includes(query) ||
      user.email?.toLowerCase()?.includes(query) ||
      user.mobile?.includes(query)
  )
})

const handleSearch = (query: string) => {
  searchQuery.value = query
}

const handlePermissionUpdate = (userId: number, value: boolean) => {
  const userIndex = users.value.findIndex(u => u.id === userId)
  if (userIndex !== -1) {
    users.value[userIndex] = {
      ...users.value[userIndex],
      canUpload: value
    }
    removeUser(userId)
  }
}
let auth = useAuth();
onMounted(() => {
  // Fetch users from API or perform any other setup
  // For example:
  console.log("mounted management")
  auth.getUsers().then((data) => {
    users.value = data;
  }).catch((error) => {
    console.error("Error fetching users:", error);
  })

})
</script>

<style scoped>
.manage-bvs-container {
  border-radius: 16px;
  border: 1px solid rgba(199, 200, 204, 0.4);
  background: var(--Neutral-background, #f7f8fc);
  display: flex;
  margin-top: 16px;
  width: 100%;
  flex-direction: column;
  padding: 24px;
}

.header-section {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}

.page-title {
  color: var(--Neutral-5, #191a1f);
  font-size: 20px;
  font-weight: 500;
  flex: 1;
  margin: 0;
}

@media (max-width: 991px) {
  .manage-bvs-container {
    padding: 16px;
    margin-top: 8px;
  }

  .header-section {
    gap: 16px;
  }

  .page-title {
    font-size: 18px;
    width: 100%;
  }
}
</style>